/* eslint-disable prettier/prettier */
/* eslint-disable */

import React, { useState } from 'react';
import {Autocomplete, Box, useMediaQuery} from '@mui/material';
import { Popper, TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { IconCloseAutocomplete, IconMobileSelectArrow, IconSelectArrow } from '../../../icons';
import { Colors } from '../../../style/variables';
import { commonTheme } from 'portfolio3/styles/theme';

import './index.scss';

const useStyles = makeStyles({
  buttonSelect: {
    '&.Mui-focused': {
      '& .achievement-form_combo': {
        borderColor: Colors['blue-primrose']
      }
    },
    '& .MuiSvgIcon-root': {
      width: '12px',
      height: '6px'
    },
    '& .MuiAutocomplete-clearIndicator': {
      marginRight: '10px',
      '& svg': {
        width: '10px',
        height: '10px'
      }
    }

  },
  textField: {
    '&.achievement-form_combo': {
      marginTop: 0,
      marginBottom: 0,
      boxSizing: 'border-box',
      border: `1px solid ${Colors['control-stroke']}`,
      borderRadius: '8px',
      outline: 'none',

      '& .MuiAutocomplete-endAdornment': {
        top: 'calc(50% - 11px)',
        right: '14px'
      },

      '& .MuiAutocomplete-inputRoot': {
        padding: '8px 16px',
        paddingRight: '39px',

        '& input': {
          padding: 0
        },
        '& fieldSet': {
          border: 'none'
        }
      },
      '& input': {
        '&::-webkit-input-placeholder': {
          color: Colors['disable-text'],
          opacity: 1
        },
        '&::-moz-placeholder': {
          color: Colors['disable-text'],
          opacity: 1
        },
        '&:-moz-placeholder': {
          color: Colors['disable-text'],
          opacity: 1
        },
        '&:-ms-input-placeholder': {
          color: Colors['disable-text'],
          opacity: 1
        },
        '&:focus::-webkit-input-placeholder': {
          color: 'transparent'
        },
        '&:focus::-moz-placeholder': {
          color: 'transparent'
        },
        '&:focus:-moz-placeholder': {
          color: 'transparent'
        },
        '&:focus:-ms-input-placeholder': {
          color: 'transparent'
        }
      },
      '& textarea': {
        '&::-webkit-input-placeholder': {
          color: Colors['disable-text'],
          opacity: 1
        },
        '&::-moz-placeholder': {
          color: Colors['disable-text'],
          opacity: 1
        },
        '&:-moz-placeholder': {
          color: Colors['disable-text'],
          opacity: 1
        },
        '&:-ms-input-placeholder': {
          color: Colors['disable-text'],
          opacity: 1
        },
        '&:focus::-webkit-input-placeholder': {
          color: 'transparent'
        },
        '&:focus::-moz-placeholder': {
          color: 'transparent'
        },
        '&:focus:-moz-placeholder': {
          color: 'transparent'
        },
        '&:focus:-ms-input-placeholder': {
          color: 'transparent'
        }
      },
      '& .MuiInput-underline:before': {
        display: 'none'
      },
      '& .MuiInput-underline:after': {
        display: 'none'
      },
      '& .MuiIconButton-label': {
        color: Colors['blue-primrose']
      },
      '& .MuiInputBase-input': {
        padding: '8px 16px'
      },
      '& .MuiOutlinedInput-notchedOutline': {
        display: 'none'
      }
    }
  },
  icon: {
    width: '12px',
    height: '6px'
  },
  mobileIcon: {
    width: '20px !important',
    height: '20px !important'
  },
  popper: {
    display: 'flex',
    'word-wrap': 'break-word',
    'flex-wrap': 'wrap',
    'word-break': 'break-word',
    width: '100%'
  }
});

interface IButtonSelectProps {
  options: any,
  placeholder: string,
  value?: any,
  label?: string,
  onChange?: any,
  loading?: boolean,
  disableClearable?: boolean,
}

const CommonStudentLinkedSelect: React.FC<IButtonSelectProps> = ({
  value,
  label,
  options,
  onChange,
  loading,
  placeholder,
  disableClearable,
  ...props
}) => {
  const isMobile = useMediaQuery(commonTheme.breakpoints.down('commonSm'));
  const classes = useStyles();
  const [textValue, setTextValue] = useState('');
  return (
    <Autocomplete
      popupIcon={isMobile ? <IconMobileSelectArrow classes={{ root: classes.mobileIcon }} /> : <IconSelectArrow classes={{ root: classes.icon }} />}
      clearIcon={<IconCloseAutocomplete classes={{ root: classes.icon }} />}
      options={options}
      getOptionLabel={(object) => (textValue ? object.value : '')}
      renderOption={(props, option) => {
        return <Box component="li" {...props}>{option.value}</Box>
      }}
      loading={loading}
      classes={{ root: classes.buttonSelect, popper: classes.popper }}
      loadingText="Загрузка"
      value={value}
      onChange={(event, value) => { onChange(event, value); setTextValue(''); }}
      disableClearable={disableClearable}
      blurOnSelect
      PopperComponent={(props) => <Popper {...props} placement="bottom-start" />}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={!isMobile ? placeholder : undefined}
          label={isMobile ? label : undefined}
          value={textValue}
          onChange={(e) => setTextValue(e.target.value)}
          margin="none"
          variant="outlined"
          className="achievement-form_combo"
          classes={{ root: classes.textField }}
        />
      )}
      {...props}
    />
  );
};

export default CommonStudentLinkedSelect;
